import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from '../comum/filtros/pipes/pipes.module';
import { ComumModule } from '../comum/comum.module';
import { routing } from '../rotas';
import { CadastroOcorrenciaComponent } from './cadastro-ocorrencia/cadastro-ocorrencia.component';
import { CadastroAgendamentoOcorrenciaComponent } from './cadastro-agendamento-ocorrencia/cadastro-agendamento-ocorrencia.component';
import { DetalheOcorrenciaComponent } from './detalhe-ocorrencia/detalhe-ocorrencia.component';
import { ComentarioOcorrenciaComponent } from './comentario-ocorrencia/comentario-ocorrencia.component';
import { ListarAgendamentoOcorrenciaComponent } from './listar-agendamento-ocorrencia/listar-agendamento-ocorrencia.component';
import { VisaoGeralOcorrenciasComponent } from './visao-geral-ocorrencias/visao-geral-ocorrencias.component';
import { FormsModule } from '@angular/forms';
import { OcorrenciasService } from './ocorrencias.service';
import { PontoFisicoService } from '../ponto-fisico/ponto-fisico.service';
import { SetorService } from '../setor/setor.service';
import { ProcessoService } from '../processo/processo.service';
import { RotinaService } from '../rotina/rotina.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ProgressbarModule } from 'ngx-bootstrap';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { CalendarModule, DropdownModule, ConfirmDialogModule, ConfirmationService, MultiSelectModule } from 'primeng/primeng';
import { ListarOcorrenciasComponent } from './listar-ocorrencias/listar-ocorrencias.component';
import { ListarOcorrenciasGraficoComponent } from './listar-ocorrencias-grafico/listar-ocorrencias-grafico.component';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { ModalReincidenciaOcorrenciaComponent } from './modal-reincidencia-ocorrencia/modal-reincidencia-ocorrencia.component';
import { ReincidenciaOcorrenciaComponent } from './reincidencia-ocorrencia/reincidencia-ocorrencia.component';

@NgModule({
  imports: [
    CommonModule,
    NgxPaginationModule,
    NgbModule,
    PipesModule,
    ComumModule,
    routing,
    FormsModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.circle
    }),
    ProgressbarModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    NgxChartsModule,
    CalendarModule,
    DropdownModule,
    MultiSelectModule,
    ConfirmDialogModule
  ],
  declarations: [CadastroOcorrenciaComponent, CadastroAgendamentoOcorrenciaComponent, DetalheOcorrenciaComponent,
    ListarAgendamentoOcorrenciaComponent, VisaoGeralOcorrenciasComponent,
    ComentarioOcorrenciaComponent, ListarOcorrenciasComponent, ListarOcorrenciasGraficoComponent,
    ModalReincidenciaOcorrenciaComponent, ReincidenciaOcorrenciaComponent],
  exports: [CadastroOcorrenciaComponent, CadastroAgendamentoOcorrenciaComponent, DetalheOcorrenciaComponent,
    ListarAgendamentoOcorrenciaComponent, VisaoGeralOcorrenciasComponent,
    ComentarioOcorrenciaComponent, ListarOcorrenciasComponent, ListarOcorrenciasGraficoComponent,
  ModalReincidenciaOcorrenciaComponent, ReincidenciaOcorrenciaComponent],
  providers: [OcorrenciasService, PontoFisicoService, SetorService, ProcessoService, RotinaService, ConfirmationService, CookieService]
})
export class OcorrenciasModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/ocorrencias.module.ts